import { motion } from "framer-motion";
import { useState } from "react";
import img2020 from "@/assets/2020.jpg";
import img2021 from "@/assets/2021.jpg";
import img2023 from "@/assets/2023.jpg";
import img20250822_215106 from "@/assets/20250822_215106.jpg";
import img2026_1 from "@/assets/2026_1.jpg";
import img2026_2 from "@/assets/2026_2.jpg";
import imgIMG_20210101_WA0026 from "@/assets/IMG-20210101-WA0026.jpg";
import imgIMG_20251206_WA0007 from "@/assets/IMG-20251206-WA0007.jpg";
import imgIMG_20260406_WA0062 from "@/assets/IMG-20260406-WA0062.jpg";
import imgIMG_20260406_WA0222 from "@/assets/IMG-20260406-WA0222.jpg";
import imgIMG_20260418_WA0004 from "@/assets/IMG-20260418-WA0004.jpg";
import imgWA_0600 from "@/assets/WhatsApp Image 2026-06-08 at 20.06.00.jpeg";
import imgWA_0701 from "@/assets/WhatsApp Image 2026-06-08 at 20.07.01.jpeg";
import imgWA_1044 from "@/assets/WhatsApp Image 2026-06-08 at 20.10.44.jpeg";

const images = [
  img2020,
  img2021,
  img2023,
  img20250822_215106,
  img2026_1,
  img2026_2,
  imgIMG_20210101_WA0026,
  imgIMG_20251206_WA0007,
  imgIMG_20260406_WA0062,
  imgIMG_20260406_WA0222,
  imgIMG_20260418_WA0004,
  imgWA_0600,
  imgWA_0701,
  imgWA_1044,
];

// Spans for sm+ tetris layout
const spans = [
  "sm:col-span-5 sm:row-span-2 h-[320px] sm:h-[640px]",
  "sm:col-span-7 h-[260px] sm:h-[310px]",
  "sm:col-span-3 h-[260px] sm:h-[320px]",
  "sm:col-span-4 h-[260px] sm:h-[320px]",
  "sm:col-span-12 h-[280px] sm:h-[420px]",
  "sm:col-span-6 h-[260px] sm:h-[360px]",
  "sm:col-span-6 h-[260px] sm:h-[360px]",
];

export default function GalleryPage() {
  const [previewImage, setPreviewImage] = useState(null);

  return (
    <div data-testid="gallery-page">
      <section
        className="border-b"
        style={{ background: "#FBF5EA", borderColor: "#EFE6D2" }}
      >
        <div className="max-w-5xl mx-auto px-5 sm:px-12 py-20 sm:py-28 text-center">
          <p className="overline">
            <span className="divider-line mr-4" />
            Through the years
            <span className="divider-line ml-4" />
          </p>
          <h1 className="font-serif-wb mt-7 text-4xl sm:text-5xl lg:text-7xl tracking-tighter">
            Moments,{" "}
            <span className="italic" style={{ color: "var(--wb-primary)" }}>
              collected.
            </span>
          </h1>
          <p
            className="mt-7 max-w-xl mx-auto text-sm sm:text-base leading-relaxed"
            style={{ color: "var(--wb-text-muted)" }}
          >
            A small archive — not the whole story, just the parts we've kept
            close.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 sm:grid-cols-12 gap-3 sm:gap-5">
          {images.map((url, i) => (
            <motion.button
              key={i}
              type="button"
              onClick={() => setPreviewImage(url)}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              className={`overflow-hidden ${spans[i] || "sm:col-span-6 h-[260px] sm:h-[360px]"}`}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={url}
                alt={`Moment ${i + 1}`}
                className="w-full h-full object-cover transition-transform duration-[1200ms] hover:scale-105"
                loading="lazy"
              />
            </motion.button>
          ))}
        </div>
      </section>

      {previewImage ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4 py-6"
          onClick={() => setPreviewImage(null)}
          role="button"
          tabIndex={0}
          aria-label="Close image preview"
        >
          <div
            className="relative max-w-[95vw] max-h-[95vh]"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              onClick={() => setPreviewImage(null)}
              className="absolute top-3 right-3 z-10 rounded-full bg-black/60 p-2 text-white hover:bg-black"
            >
              ×
            </button>
            <img
              src={previewImage}
              alt="Preview"
              className="max-w-full max-h-[90vh] rounded-xl object-contain"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
